import { Link } from 'react-router-dom';
import { useTranslation } from 'hooks';
import { appRoute } from 'shared/constants/routes';
import cls from './trial-banner.module.scss';

export type TrialBannerVariant = 'prominent' | 'subtle' | 'subtleContrast';

interface TrialBannerProps {
  title: React.ReactNode;
  description: React.ReactNode;
  onActionClick?: React.MouseEventHandler<HTMLAnchorElement>;
  className?: string;
  variant?: TrialBannerVariant;
}

export const TrialBanner: React.FC<TrialBannerProps> = ({
  title,
  description,
  onActionClick,
  className,
  variant = 'subtle',
}) => {
  const { t } = useTranslation();
  const bannerClassName = [cls.banner, cls[variant], className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={bannerClassName}>
      <div className={cls.content}>
        <h4 className={cls.title}>{title}</h4>
        <p className={cls.description}>{description}</p>
      </div>

      <Link
        className={cls.action}
        to={appRoute('/payment')}
        onClick={onActionClick}
      >
        {t('upgrade')}
      </Link>
    </div>
  );
};
